var taricMeasure= angular.module('taric.measure', ['taric.measure.ccrm', 'taric.measure.mcc', 'common.model.measuretype']);
taricMeasure.config(function ($stateProvider) {
    $stateProvider.state('taric.measure', {
                    abstract: true,
                    url: '/measure',
                    template: '<ui-view></ui-view>'
                }).state('taric.measure.ccrm', {
                    url: '/ccrm/search?frm&sd&d&cc&mt&co&l',
                    templateUrl: 'taric/measure/ccrm/measure-ccrm-search.tmpl.html',
                    controller : 'SearchMeasuresByCCController as searchMeasuresByCCCtrl',
                    reloadOnSearch: false,
                    resolve: {
                        authenticated: function(AuthorizeModel, LoginHelper, CONSTANTS, $q){
                            let deferred = $q.defer();
                            if (AuthorizeModel.loggedIn) {
                                deferred.resolve();
                            } else if (CONSTANTS.credentialSetting === 'BASIC') {
                                LoginHelper.goToLogin();
                                deferred.reject('User is not authenticated');
                            } else {
                                deferred.reject('User is not authenticated');
                            }
                            return deferred.promise;
                        },
                        initializeData: function(MeasureByCCSearchModel, $stateParams, $translate, $filter, CommonHelper){
                            if ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView') {
                                MeasureByCCSearchModel.reset();
                            } else if ($stateParams.frm === 'ccLookup') {
                                MeasureByCCSearchModel.resetSearchResult();
                            }

                            if ($stateParams.sd){
                                var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                                if (inputDate) {
                                    MeasureByCCSearchModel.getSearchCriteria().simulationDate = inputDate;
                                }
                            }
                            if($stateParams.d){
                                if ($stateParams.d === 'I' || $stateParams.d === 'E'){
                                    MeasureByCCSearchModel.getSearchCriteria().direction = $stateParams.d;
                                }
                            }
                            if ($stateParams.cc){
                                MeasureByCCSearchModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                            }
                            if ($stateParams.mt) {
                                MeasureByCCSearchModel.getSearchCriteria().measureType = $stateParams.mt;
                            }
                            if ($stateParams.co) {
                                MeasureByCCSearchModel.getSearchCriteria().country = $stateParams.co;
                            }
                            if ($stateParams.l){
                                $translate.use($stateParams.l);
                            }
                        },
                        measureTypes: function(MeasureByCCSearchModel, MeasureTypeModel){
                            return MeasureTypeModel.getMeasureTypes(MeasureByCCSearchModel.getSearchCriteria().direction, MeasureByCCSearchModel.getSearchCriteria().simulationDate);
                        },
                        countries: function(GeographicalAreaModel, MeasureByCCSearchModel, $stateParams){
                            var result = null;
                            // Only get countries to support bookmark when there are required parameters.
                            if (!$stateParams.frm && $stateParams.sd && $stateParams.cc && $stateParams.co) {
                                result = GeographicalAreaModel.getCountriesOfOrigin(MeasureByCCSearchModel.getSearchCriteria().simulationDate);
                            }
                            return result;
                        },
                        loadTranslation: function ($translatePartialLoader) {
                            $translatePartialLoader.addPart('taric/measure/ccrm');
                            $translatePartialLoader.addPart('taric/quota');
                        },
                        setupMenu: function (MenuModel) {
                        	
                        	MenuModel.setHelpIndex(this.name);
                        	MenuModel.notifyObservers();
                        }
                    }
                }).state('taric.measure.mcc', {
                        url: '/mcc/search?frm&cc&sd&d&ad&co&cu&l&pv',
                        templateUrl: 'taric/measure/mcc/measure-mcc-search.tmpl.html',
                        controller : 'SearchMeasuresForNomenclatureController as searchMeasuresForNomCtrl',
                        reloadOnSearch: false,
                        resolve: {
                            initializeData: function(MeasureForNomenclatureSearchModel, $stateParams, $translate, $filter, CommonHelper){
                                if ($stateParams.frm !== 'taric.duty.meursing' &&
                                    $stateParams.frm !== 'adcoLookup' &&
                                    $stateParams.frm !== 'ccLookup' &&
                                    $stateParams.frm !== 'calDuties' &&
                                    $stateParams.frm !== 'ccView') {
                                    MeasureForNomenclatureSearchModel.reset();
                                } else if (($stateParams.frm === 'taric.duty.meursing' && $stateParams.ad !== '7XXX') ||
                                    $stateParams.frm === 'adcoLookup' ||
                                    $stateParams.frm === 'ccLookup') {
                                    MeasureForNomenclatureSearchModel.resetSearchResult();
                                }
                                if ($stateParams.cc){
                                    MeasureForNomenclatureSearchModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                                }
                                if ($stateParams.d){
                                    if ($stateParams.d === 'I' || $stateParams.d === 'E'){
                                        MeasureForNomenclatureSearchModel.getSearchCriteria().direction = $stateParams.d;
                                    }
                                }
                                if ($stateParams.sd){
                                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                                    if (inputDate) {
                                        MeasureForNomenclatureSearchModel.getSearchCriteria().simulationDate = inputDate;
                                    }
                                }
                                if ($stateParams.ad){
                                    if ($stateParams.ad === '7XXX') {
                                        // Return from meursing search with additional code
                                        // Dummy value for "not selected"
                                        MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCode = null;
                                    } else if ($stateParams.frm === 'adcoLookup' || $stateParams.frm === 'taric.duty.meursing') {
                                        MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCode = $stateParams.ad;
                                    } else {
                                        var additionalCodes = $stateParams.ad.split(',');
                                        // In case AdditionalCode parameter is returned from lookup AdditionalCode,
                                        // it will be added to the current additionalCode list SearchCriteria.
                                        for (let i = 0; i < additionalCodes.length; i++) {
                                            if (MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCodes.indexOf(additionalCodes[i]) < 0) {
                                                var adcoItem = {id: additionalCodes[i]};
                                                MeasureForNomenclatureSearchModel.getSearchCriteria().additionalCodes.push(adcoItem);
                                            }
                                        }
                                    }
                                }
                                if ($stateParams.co) {
                                    MeasureForNomenclatureSearchModel.getSearchCriteria().country = $stateParams.co;
                                }
                                if ($stateParams.cu) {
                                    MeasureForNomenclatureSearchModel.getSearchCriteria().currency = $stateParams.cu;
                                }
                                if ($stateParams.l){
                                    $translate.use($stateParams.l);
                                }
                                if ($stateParams.pv){
                                    MeasureForNomenclatureSearchModel.getSearchCriteria().preferenceCodeMappingVersion = $stateParams.pv;
                                }
                            },
                            countries: function(GeographicalAreaModel, MeasureForNomenclatureSearchModel, $stateParams){
                                var result = null;
                                // Only get countries to support bookmark when there are required parameters.
                                if (!$stateParams.frm && $stateParams.sd && $stateParams.cc && $stateParams.co) {
                                    result = GeographicalAreaModel.getCountriesOfOrigin(MeasureForNomenclatureSearchModel.getSearchCriteria().simulationDate);
                                }
                                return result;
                            },
                            currencies: function(MonetaryUnitsModel, MeasureForNomenclatureSearchModel){
                                return MonetaryUnitsModel.dutyMonetaryUnits(MeasureForNomenclatureSearchModel.getSearchCriteria().simulationDate);
                            },
                            loadTranslation: function ($translatePartialLoader) {
                                $translatePartialLoader.addPart('taric/measure/mcc');
                                $translatePartialLoader.addPart('taric/quota');
                            },
                            setupMenu: function (MenuModel) {
                            	
                            	MenuModel.setHelpIndex(this.name);
                            	MenuModel.notifyObservers();
                            }
                        }
                 });

    });


// WEBPACK FOOTER //
// ./app/taric/measure/taric-measure.js